import routes from 'netxcore@netx/core-app/routes';

// Deferred module routes
Object.assign(routes, {
	'document(/*anything)'() {
		dispatcher.trigger('netx:load:module:pdfViewer', {loadUrl: true});
	},
});

export default routes;
